import { Container } from "react-bootstrap";
import Carousel from "react-bootstrap/Carousel";
import "./IntCarousel.css"; // Import the CSS file

function IntCarousel() {
  return (
    <Container>
      <Carousel>
        <Carousel.Item>
          <img
            className="d-block w-100 carousel-image"
            src="/assets/images/interior.jpg"
            alt="First slide"
          />
          <Carousel.Caption>
            <h3>Interior 1</h3>
            <p>Interior 1</p>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block w-100 carousel-image"
            src="/assets/images/interior3.jpg"
            alt="Second slide"
          />
          <Carousel.Caption>
            <h3>Second Interior</h3>
            <p>Interior 2nd</p>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block w-100 carousel-image"
            src="/assets/images/interior4.jpg"
            alt="Third slide"
          />
          <Carousel.Caption>
            <h3>Third Interior</h3>
            <p>
              3rd Interior
            </p>
          </Carousel.Caption>
        </Carousel.Item>
      </Carousel>
    </Container>
  );
}

export default IntCarousel;
